import { render, staticRenderFns } from "./VesselIndex.vue?vue&type=template&id=1bb7ff24&scoped=true&"
import script from "./VesselIndex.vue?vue&type=script&lang=js&"
export * from "./VesselIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb7ff24",
  null
  
)

export default component.exports